module.exports = "<footer class=\"sticky-footer bg-white\">\n  <div class=\"container my-auto\">\n      <div class=\"copyright text-center my-auto\">\n          <span>Copyright &copy; Lynkit 2021</span>\n      </div>\n  </div>\n</footer>"


//////////////////
// WEBPACK FOOTER
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/footer/footer.component.html
// module id = ../../../../../src/app/footer/footer.component.html
// module chunks = main